import React, { useEffect, useMemo, useRef, useState } from "react";
import MaestroLoader from "@components/MaestroLoader";
import ErrorLoadingWidget from "./ErrorLoadingWidget";
import { LoadingWidget } from "./LoadingWidget";
import { Box, Button, CardCover, Checkbox, Grid, Input, List, ListDivider, ListItem, ListItemDecorator, Typography } from "@mui/joy";
import CardWidget from "./layouts/CardWidget";
import { useDebounce } from "@uidotdev/usehooks";
import DoneIcon from '@mui/icons-material/Done';
import DeleteButton from "@components/DeleteButton";

export default function TodoWidget(props) {
    const [isSyncing, setIsSyncing] = useState(false);
    const [isSynced, setIsSynced] = useState(true);
    const didMount = useRef(false);

    const [todos, setTodos] = useState(props?.options?.todos ?? []);
    const debouncedTodos = useDebounce(todos, 500); // only save todo list a max of every 500ms

    const [newTask, setNewTask] = useState('');

    // todo: modal for removing todo

    // console.log(props);
    // console.log(Object.keys(props));

    useEffect(() => {
        if(!didMount.current) {
            return;
        }

        setIsSynced(false);
    }, [todos]);

    useEffect(() => {
        if(!didMount.current) {
            didMount.current = true;
            // console.log('will NOT update todos');
            return;
        }

        setIsSyncing(true);

        // remove the additional fields
        const widget = props.widget;
        widget.options.todos = todos;
        props.updateWidget(widget).then(() => {
            setIsSynced(true);
            // setTimeout(() => setIsSyncing(false), 300);
            setIsSyncing(false);
        });
    }, [debouncedTodos]);

    const toggleTodo = (index) => {
        let _todos = [...todos];
        _todos[index].completed = !_todos[index].completed;
        setTodos(_todos);
    }

    const addNewTask = (event) => {
        event.preventDefault();
        // console.log(event);

        let _todos = [...todos];
        _todos.push({
            completed: false,
            todo: newTask,
        });
        setTodos(_todos);

        // reset
        setNewTask('');
    }

    const deleteTodo = (index) => {
        let _todos = [...todos];
        _todos.splice(index, 1);
        // _todos[index].completed = !_todos[index].completed;
        setTodos(_todos);
        //
    };

    const sortedTodos = todos;
    /*
    // this doesn't resort tasks
    const sortedTodos = useMemo(
          () => todos.sort((a, b) => {
            return a.completed - b.completed;
        }),
        [todos]
    );
    */


    return (
        <CardWidget
            unpadded
            {...props}
            title={`To-do: ${props.options.name}`}
            syncing={isSyncing}
            synced={isSynced}
        >

        <List size="sm">
            <ListItem component={'form'} onSubmit={addNewTask}>
                <Input
                    variant="outlined"
                    value={newTask}
                    onChange={(event) => setNewTask(event.target.value)}
                    // id={name}
                    type={'text'}
                    placeholder="What needs to be done?"
                    endDecorator={<Button disabled={!newTask.length} type="submit">Add</Button>}
                    sx={{
                        width: '100%',
                        minWidth: '100px',
                    }}
                    // {...register(name, config)}
                    // defaultValue={defaultValue}
                    // {...restProps}
                />
            </ListItem>
        <ListDivider/>
        {todos.length === 0 && (
            <ListItem>
                <Typography size="sm">There is nothing in this to-do list.</Typography>
            </ListItem>
        )}

            {sortedTodos.map((todo, todoIndex) => {
                return (
                    <ListItem
                        key={todoIndex}
                        variant="outlined"
                        sx={{
                            borderRadius: 'sm',
                            boxShadow: 'sm',
                            border: 1,
                            borderColor: 'background.level3',
                            mx: 1,
                            my: 0.25,
                            p: 1.5,
                            '&:hover': {
                                bgcolor: 'background.level1',
                            },
                            ...(todo.completed && {
                                '.MuiCheckbox-root': {
                                textDecoration: 'line-through',
                                opacity: 0.7,
                                },
                            }),
                            '.MuiCheckbox-action': {
                                mr: '32px',
                            }
                        }}
                        endAction={<DeleteButton onDelete={() => deleteTodo(todoIndex)} />}

                    >
                    <Checkbox
                        overlay
                        // size="lg"
                        uncheckedIcon={<DoneIcon />}
                        checked={todo.completed}
                        label={todo.todo}
                        onChange={()=>toggleTodo(todoIndex)}
                        slotProps={{
                            root: ({ checked, focusVisible }) => ({
                            sx: !checked
                                ? {
                                    '& svg': { opacity: focusVisible ? 1 : 0 },
                                    '&:hover svg': {
                                    opacity: 1,
                                    },
                                }
                                : undefined,
                            }),
                        }}
                        />
                    </ListItem>
                );
            })}
            </List>
        </CardWidget>
    );
}
